// src/api/axiosInstance.js

import axios from "axios";
import { toast } from "react-toastify";

// Axios instans yaradırıq
const axiosInstance = axios.create({
  baseURL: "https://api.herracim.az/api",
  withCredentials: true
});

// 🔥 Response interceptor əlavə edirik
axiosInstance.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      if (error.response.data === "İstifadəçi ban olunub.") {
        localStorage.removeItem("token");
        document.cookie = "token=; Max-Age=0; path=/;";
        toast.error("Sizin hesabınız ban olunmuşdur. Sistemə giriş imkanı yoxdur.");
        window.location.href = "/giris";
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
